import { render, staticRenderFns } from "./FilterRuleTableButton.vue?vue&type=template&id=71213fa4&"
import script from "./FilterRuleTableButton.vue?vue&type=script&lang=js&"
export * from "./FilterRuleTableButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports